var map = {
	"./accounts-room.jpg": 68,
	"./accounts-team.jpg": 69,
	"./case-cockpit.jpg": 70,
	"./case-final-exam.jpg": 71,
	"./case-meeting-rooms.jpg": 72,
	"./case-norwegian-1.jpg": 73,
	"./case-norwegian-2.jpg": 74,
	"./case-novair.jpg": 75,
	"./case-pelesys-1.jpg": 76,
	"./case-pelesys-2.jpg": 77,
	"./case-realestate.jpg": 78,
	"./case-yachts.jpg": 79,
	"./learn-test-export.jpg": 80,
	"./mountains-big.jpg": 81,
	"./mountains-small-taggis.jpg": 82,
	"./mountains-small.jpg": 83,
	"./new-laptop.jpg": 35,
	"./taggis-and-docbrowser.jpg": 84,
	"./taggis-brochure.jpg": 36,
	"./trial-mac.jpg": 85,
	"./upload-visuals-old.jpg": 86,
	"./video-see-how.jpg": 87,
	"./video-watch-taggis.jpg": 88
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.jpg$
// module id = 284
// module chunks = 3